<template>
  <div class="basic-info-tab">
    <h3 class="gm-section-title">Basic Information</h3>

    <div class="form-group gm-field">
      <label class="gm-label">Template Name</label>
      <input
        type="text"
        class="gm-input"
        placeholder="Enter template name"
        :value="template.data.name"
        @input="updateTemplateName"
      />
    </div>

    <div class="form-group gm-field">
      <label class="gm-label">Tags</label>
      <div class="tags-container">
        <span v-for="(tag, index) in template.data.tags" :key="index" class="tag gm-chip">
          {{ tag }}
          <button class="tag-remove" @click="service.removeTag(tag)">×</button>
        </span>
        <input
          type="text"
          placeholder="Add tag"
          class="tag-input gm-input"
          @keydown.enter="addTag"
          v-model="newTag"
        />
      </div>
    </div>

    <div class="form-group gm-field">
      <label class="gm-label">Rank</label>
      <input
        type="number"
        class="gm-input"
        :value="template.data.rank"
        @input="updateRank"
        min="1"
        :max="template.validation.max_rank_grade"
      />
      <span class="input-hint">Max: {{ template.validation.max_rank_grade }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BasicInfoTab',
  props: {
    template: {
      type: Object,
      required: true
    },
    service: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      newTag: ''
    };
  },
  methods: {
    updateTemplateName(event) {
      this.service.setName(event.target.value);
      this.$emit('update');
    },
    updateRank(event) {
      this.service.setRank(parseInt(event.target.value, 10));
      this.$emit('update');
    },
    addTag() {
      if (this.newTag.trim()) {
        this.service.addTag(this.newTag.trim());
        this.newTag = '';
        this.$emit('update');
      }
    }
  }
};
</script>

<style scoped>
.basic-info-tab {
  padding: 20px 0;
}

.form-group {
  margin-bottom: 20px;
}

.tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: var(--gm-gap-xs);
  margin-top: var(--gm-gap-xs);
  align-items: center;
}

.tag-remove {
  background: none;
  border: none;
  color: var(--gm-accent);
  cursor: pointer;
  font-size: 1rem;
  padding: 0 0 0 5px;
  margin: 0;
  line-height: 1;
}

.tag-input {
  min-width: 8rem;
  width: auto;
}

.input-hint {
  font-size: 0.8rem;
  color: var(--gm-text-muted);
  margin-left: var(--gm-gap-xs);
}

h3 {
  margin-top: 0;
}
</style>